export const environment = {
  production: true,
  envName: "LatestEu",
  appInsights: {
    instrumentationKey: "3e064876-1cd7-4abe-89f2-00af74c19a63",
  },
};
